import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { useFormikContext } from 'formik';
import { FC } from 'react';

interface Props extends Pick<LoadingButtonProps, 'fullWidth' | 'sx'> {
  title?: string;
}

export const FormSubmitButton: FC<Props> = ({
  fullWidth,
  sx,
  title = 'Submit',
}) => {
  const { dirty, isSubmitting, isValid } = useFormikContext();

  return (
    <LoadingButton
      disabled={!isValid || !dirty || isSubmitting}
      fullWidth={fullWidth}
      loading={isSubmitting}
      sx={{ marginTop: '10px', ...sx }}
      type="submit"
      variant="contained"
    >
      {title}
    </LoadingButton>
  );
};
